<template>
  <b-card no-body>
    <div class="m-2">
      <b-row>
        <b-col cols="12" md="6" class="mb-1">
          <b-button variant="primary" @click="showAddModal = true">
            Thêm Template mới
          </b-button>
        </b-col>
        <b-col cols="12" md="6" class="mb-1">
          <b-input-group>
            <b-form-input v-model="searchQuery" placeholder="Tìm kiếm..."></b-form-input>
            <b-input-group-append>
              <b-button variant="outline-primary" @click="loadData">Tìm</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table hover :items="items" :fields="fields" show-empty empty-text="Không có dữ liệu">
        <template #cell(STATUS)="data">
          <b-badge :variant="data.value == 1 ? 'success' : 'secondary'">
            {{ data.value == 1 ? 'Active' : 'Inactive' }}
          </b-badge>
        </template>
        <template #cell(actions)="data">
          <b-button size="sm" variant="info" class="mr-1" @click="editTemplate(data.item)">Sửa</b-button>
          <b-button size="sm" variant="danger" @click="deleteTemplate(data.item.ID)">Xóa</b-button>
        </template>
      </b-table>
      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" @change="pageChanged"></b-pagination>
    </div>

    <!-- Modal -->
    <b-modal v-model="showAddModal" :title="isEdit ? 'Sửa Template' : 'Thêm Template'" @ok="saveTemplate" ok-title="Lưu" cancel-title="Hủy">
      <b-form-group label="Template ID (Iris/Zalo)">
        <b-form-input v-model="form.TEMPLATE_ID" required></b-form-input>
      </b-form-group>
      <b-form-group label="Tên Template">
        <b-form-input v-model="form.TEMPLATE_NAME" required></b-form-input>
      </b-form-group>
      <b-form-group label="Các biến Params (ngăn cách bởi dấu phẩy, vd: so_thue_bao,ten_kh)">
        <b-form-input v-model="form.PARAMS_CONFIG_STR" required></b-form-input>
      </b-form-group>
      <b-form-group label="Trạng thái">
        <b-form-select v-model="form.STATUS" :options="[{value:1,text:'Active'},{value:0,text:'Inactive'}]"></b-form-select>
      </b-form-group>
    </b-modal>
  </b-card>
</template>

<script>
import axios from 'axios'
import {
  BCard, BRow, BCol, BButton, BInputGroup, BFormInput, BInputGroupAppend,
  BTable, BBadge, BPagination, BModal, BFormGroup, BFormSelect
} from 'bootstrap-vue'

export default {
  name: 'ZnsTemplate',
  components: {
    BCard, BRow, BCol, BButton, BInputGroup, BFormInput, BInputGroupAppend,
    BTable, BBadge, BPagination, BModal, BFormGroup, BFormSelect
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'ID', label: 'ID' },
        { key: 'TEMPLATE_ID', label: 'Template ID' },
        { key: 'TEMPLATE_NAME', label: 'Tên Template' },
        { key: 'PARAMS_CONFIG', label: 'Cấu hình biến' },
        { key: 'STATUS', label: 'Trạng thái' },
        { key: 'actions', label: 'Thao tác' }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      searchQuery: '',
      showAddModal: false,
      isEdit: false,
      form: {
        ID: null,
        TEMPLATE_ID: '',
        TEMPLATE_NAME: '',
        PARAMS_CONFIG_STR: '',
        STATUS: 1
      }
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      axios.get(`/api/tool/zns-template/list?page=${this.currentPage}&limit=${this.perPage}&keyword=${this.searchQuery}`)
        .then(res => {
          this.items = res.data.data;
          this.totalRows = res.data.total;
        }).catch(err => {
          console.error(err);
        })
    },
    pageChanged(page) {
      this.currentPage = page;
      this.loadData();
    },
    editTemplate(item) {
      this.isEdit = true;
      this.form = {
        ID: item.ID,
        TEMPLATE_ID: item.TEMPLATE_ID,
        TEMPLATE_NAME: item.TEMPLATE_NAME,
        PARAMS_CONFIG_STR: item.PARAMS_CONFIG ? JSON.parse(item.PARAMS_CONFIG).join(',') : '',
        STATUS: item.STATUS
      };
      this.showAddModal = true;
    },
    saveTemplate(bvModalEvent) {
      bvModalEvent.preventDefault();
      let payload = {
        TEMPLATE_ID: this.form.TEMPLATE_ID,
        TEMPLATE_NAME: this.form.TEMPLATE_NAME,
        PARAMS_CONFIG: this.form.PARAMS_CONFIG_STR.split(',').map(s => s.trim()).filter(s => s),
        STATUS: this.form.STATUS
      };
      if (this.isEdit) {
        payload.ID = this.form.ID;
        axios.post('/api/tool/zns-template/update', payload).then(res => {
          this.showAddModal = false;
          this.loadData();
        })
      } else {
        axios.post('/api/tool/zns-template/add', payload).then(res => {
          this.showAddModal = false;
          this.loadData();
        })
      }
    },
    deleteTemplate(id) {
      if (confirm('Bạn có chắc muốn xóa template này?')) {
        axios.post('/api/tool/zns-template/delete', { ID: id }).then(res => {
          this.loadData();
        })
      }
    }
  },
  watch: {
    showAddModal(val) {
      if (!val) {
        this.isEdit = false;
        this.form = { ID: null, TEMPLATE_ID: '', TEMPLATE_NAME: '', PARAMS_CONFIG_STR: '', STATUS: 1 };
      }
    }
  }
}
</script>
